module.exports = __webpack_public_path__ + "img/star-half-stroke.fd83c732.svg";